import React from 'react';
import { Icon } from '@ss/mtd-react';
import { useRootStore } from '@src/model';
import { downFile } from '@utils/xhrDownload';

import './index.scss';

const SampleReelView = (props) => {
  const { data, type, setMode } = props;
  const { campusResumeFormRefStore, socialResumeFormRefStore, socialResumeDetail, campusResumeDetail } = useRootStore();
  let storeRef;
  let store;
  if (type === 'campus') {
    storeRef = campusResumeFormRefStore;
    store = campusResumeDetail;
  }
  if (type === 'social') {
    storeRef = socialResumeFormRefStore;
    store = socialResumeDetail;
  }

  const handleEdit = () => {
    setMode('edit');
    storeRef.setCurrentScrollRef('upload_sample_reel_edit');
  };

  const handleIconImg = (param: string) => {
    if (param === 'pdf') return require('../../../../../../imgs/pdf.svg');
    if (param === 'zip' || param === 'rar' || param === '7z') return require('../../../../../../imgs/zip.svg');
    return require('../../../../../../imgs/unknow.svg');
  };

  return (
    <div className="sample_reel_view model_view">
      <div className="model_title">
        <div>作品集</div>
        <div className="edit_icon" onClick={() => handleEdit()}>
          <Icon type="edit-o" style={{ color: '#A9AFB8', fontSize: 22 }} />
        </div>
      </div>
      <div className="model_main">
        {data?.map((item) => (
          <div className="model_list" key={item.renderId}>
            {/*  eslint-disable-next-line import/no-dynamic-require */}
            <img className="icon" src={handleIconImg(item.type)} alt="" />
            <div className="name">{item.name}</div>
            <div className="list_icon">
              <Icon
                type="download-o"
                onClick={() => {
                  downFile(item.fileId, item.name, store.resumeUnionId);
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SampleReelView;
